<template>
  <div>
    <ModuleHeader>Reporte rondas vendidas</ModuleHeader>
    <v-overlay :value="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="12">
                <v-menu
                  v-model="menuFechaInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      @input="getAperturas()"
                      v-model="input_date"
                      label="Fecha Inicial"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date"
                    @input="
                      menuFechaInicial = false;
                      getAperturas();
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" cols="12">
                <v-menu
                  v-model="menuFechaInicial2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      @input="getAperturas()"
                      v-model="input_date_final"
                      label="Fecha Final"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="input_date_final"
                    @input="
                      menuFechaInicial2 = false;
                      getAperturas();
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2" cols="12">
                <v-autocomplete
                  @input="getAperturas()"
                  label="Departamentos"
                  v-model="selectDep"
                  item-text="Nombre"
                  item-value="id"
                  :items="departamentos"
                ></v-autocomplete>
              </v-col>
              <v-col md="3" cols="12">
                <v-autocomplete
                  label="Cliente"
                  item-value="value"
                  v-model="selectClient"
                  :items="comp_clients"
                ></v-autocomplete>
              </v-col>
              <v-col md="3" cols="12">
                <v-text-field
                  v-model="input_folio"
                  label="Folio de Venta"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-autocomplete
                  label="Turno"
                  v-model="selectTurno"
                  item-value="Turno"
                  item-text="Desc"
                  :items="turnosList"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" small color="primary"
                      >Buscar turnos</v-btn
                    >
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn
                  depressed
                  @click="cleanFilter()"
                  class="mx-2"
                  color="error"
                >
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="3"
                ><h4>
                  Vendidas:
                  {{
                    this.$pgsHelper.formatNumber(
                      parseFloat(comp_totales.Cantidad).toFixed(2)
                    )
                  }}
                </h4>
              </v-col>
              <v-col md="3">
                <h4>
                  Total: ${{
                    this.$pgsHelper.formatNumber(
                      parseFloat(comp_totales.Monto).toFixed(2)
                    )
                  }}
                </h4>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="8"> Resultados: </v-col>
              <v-col md="4" class="text-right">
                <v-btn color="green" dark @click="exportExcel"
                  ><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                    type="xls"
                    name="Rondas Vendidas"
                    :data="datos.processedData"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Cliente</th>
                  <th>Membresia</th>
                  <th>Folio</th>
                  <th>Departamento</th>
                  <th>Clave SAT</th>
                  <th>Familia</th>
                  <th>Categoría</th>
                  <th>Descripción</th>
                  <th>Cantidad</th>
                  <th>Total</th>
                  <th>Moneda</th>
                  <th>Método de pago</th>
                  <th>Descuento ({{ currencyClass.getCurrencyDefault() }})</th>
                  <th>Autorización</th>
                  <th>Subtotal ({{ currencyClass.getCurrencyDefault() }})</th>
                  <th>Impuestos ({{ currencyClass.getCurrencyDefault() }})</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datos.processedData.length == 0">
                  <td colspan="16">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in datos.processedData">
                  <tr :key="index">
                    <td>{{ prod.Fecha }}</td>
                    <td>{{ prod.Cliente }}</td>
                    <td>{{ prod.Membresia }}</td>
                    <td>{{ prod.Folio }}</td>
                    <td>{{ prod.Departamento }}</td>
                    <td>{{ prod.ClaveSAT }}</td>
                    <td>{{ prod.Familia }}</td>
                    <td>{{ prod.Categoria }}</td>
                    <td>{{ prod.Producto }}</td>
                    <td>{{ prod.Cantidad }}</td>
                    <td>{{ $pgsHelper.formatNumber(prod.Monto) }}</td>
                    <td>{{ prod.Moneda }}</td>
                    <td>{{ prod.TipoPago }}</td>
                    <td>{{ $pgsHelper.formatNumber(prod.Descuento) }}</td>
                    <td>{{ prod.Autorizacion }}</td>
                    <td>{{ $pgsHelper.formatNumber(prod.Subtotal) }}</td>
                    <td>{{ $pgsHelper.formatNumber(prod.Impuestos) }}</td>
                  </tr>
                </template>
                <tr style="background: #e0e0e04f">
                  <td><b>TOTALES</b></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(
                        parseFloat(comp_totales.Cantidad).toFixed(2)
                      )
                    }}</b>
                  </td>
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(
                        parseFloat(comp_totales.Monto).toFixed(2)
                      )
                    }}</b>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(
                        parseFloat(comp_totales.Descuento).toFixed(2)
                      )
                    }}</b>
                  </td>
                  <td></td>
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(
                        parseFloat(comp_totales.Subtotal).toFixed(2)
                      )
                    }}</b>
                  </td>
                  <td>
                    <b>{{
                      this.$pgsHelper.formatNumber(
                        parseFloat(comp_totales.Impuestos).toFixed(2)
                      )
                    }}</b>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped></style>

<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import { mapActions } from "vuex";

export default {
  name: "ReporteGeneral",
  components: {
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      selectTurno: "ALL",
      aperturas: [],
      selectDep: "ALL",
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      showEstad: false,
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],
      datos: {
        all: [],
        processedData: [],
      },
      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
    };
  },
  computed: {
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    comp_totales() {
      let total = {
        Cantidad: 0,
        Descuento: 0,
        Monto: 0,
        Subtotal: 0,
        Impuestos: 0,
      };
      this.datos.processedData.forEach((prod) => {
        total.Cantidad += Number(prod.Cantidad);
        let totalMonto = Number(prod.Subtotal) + Number(prod.Impuestos);
        total.Monto += Number(totalMonto);
        total.Descuento += Number(prod.Descuento);
        total.Subtotal += Number(prod.Subtotal);
        total.Impuestos += Number(prod.Impuestos);
      });
      return total;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.datos.processedData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Rondas Vendidas.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    async getAperturas() {
      const startDate = this.input_date;
      const endDate = this.input_date;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = "";
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    processVentas() {
      let productosVenta = [];
      this.datos.all.forEach((el) => {
        let pagos = Object.entries(el.Pagos);
        let client = this.$pgsHelper.searchIndex(
          this.comp_clients,
          "Id",
          el.Cliente.Id
        );
        let idMembresia = client.ExtraData?.Membresia?.Membresia;
        let Membresia = this.$pgsHelper.searchIndex(
          this.Membresias,
          "Id",
          idMembresia
        );
        el.Catalogo.forEach((prod) => {
          try {
            if (prod.Tip === "RVA-Reserva") {
              Object.entries(prod.Pagos).forEach((pago) => {
                let noGrava = false;
                if (
                  prod.Nombre.includes("Nueva Membresia") ||
                  prod.Nombre.includes("Cuota Extraordinaria")
                ) {
                  noGrava = true;
                }
                let iva = prod.Iva / 100 + 1;
                let imp = !noGrava
                  ? parseFloat(pago[1].def.C - pago[1].def.C / iva).toFixed(2)
                  : 0;
                let st = !noGrava
                  ? parseFloat(pago[1].def.C - imp).toFixed(2)
                  : parseFloat(pago[1].def.C).toFixed(2);
                let producto = {
                  Fecha: el.FechaVenta,
                  Cliente: el.Cliente.Nombre,
                  Membresia: Membresia
                    ? Membresia?.Code?.Pre + "-" + Membresia?.Code?.Pos
                    : "N/A",
                  Folio: el.Folio,
                  Departamento: el.Departamento,
                  ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                  Familia: prod.Familia ? prod.Familia.N : "-",
                  Categoria: prod.Categoria ? prod.Categoria.N : "-",
                  Producto: prod.Nombre,
                  Cantidad: pago[0] ? Number(parseFloat(pago[1].cnt).toFixed(2)) : "",
                  Monto: Number(pago[1].rel.C),
                  Moneda: pago[1].rel.M,
                  TipoPago: pago[0] ? pago[1].name : "",
                  Descuento: pago[1].dsc
                    ? Number(parseFloat(pago[1].dsc.C).toFixed(2))
                    : "-",
                  Autorizacion: pago[0] ? pago[1].code : "",
                  //Impuestos:((pago[1].def.C/100)*16),
                  Subtotal: Number(st),
                  Impuestos: Number(imp),
                };
                productosVenta.push(producto);
              });
            } else if (prod.Tip === "Cupon") {
              prod.Catalogo.forEach((subProd) => {
                if (subProd.Tip === "RVA-Reserva") {
                  let iva = prod.Iva / 100 + 1;
                  let imp = 0;
                  let st = 0;
                  let producto = {
                    Fecha: el.FechaVenta,
                    Cliente: el.Cliente.Nombre,
                    Membresia: Membresia
                      ? Membresia?.Code?.Pre + "-" + Membresia?.Code?.Pos
                      : "N/A",
                    Folio: el.Folio,
                    Departamento: el.Departamento,
                    ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                    Familia: prod.Familia ? prod.Familia.N : "-",
                    Categoria: subProd.Categoria ? subProd.Categoria.N : "-",
                    Producto: subProd.Nombre,
                    Cantidad: Number(subProd.Cnt),
                    Monto: Number(0),
                    Moneda: this.$Currencies.getCurrencyDefault(),
                    TipoPago: "",
                    Descuento: Number(0),
                    Autorizacion: "",
                    //Impuestos:((pago[1].def.C/100)*16),
                    Subtotal: Number(st),
                    Impuestos: Number(imp),
                  };
                  productosVenta.push(producto);
                }
              });
            }
          } catch (e) {
            console.log(el.Folio);
          }
        });
      });
      this.datos.processedData = productosVenta;
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      filter.push(
        firestore.where("_ProdIdx", "array-contains-any", ["Reserva-Golf"])
      );

      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      let preData = [];
      preData = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      preData.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });

      preData = this.$_.orderBy(preData, "fecha", "desc");
      this.datos.all = preData;
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    searchVentas() {
      Promise.resolve()
        .then(() => {
          this.loadingData = true;
        })
        .then(() => {
          return this.getVentas();
        })
        .then(() => {
          this.loadingData = false;
        })
        .then(() => {
          return this.$nextTick();
        })
        .then(() => {
          this.processVentas();
        });
    },
  },
  beforeCreate: function () {},
  beforeMount: function () {
    this.getAperturas();
    this.getCategories();
    this.getFamilias();
    this.getVentas();
    this.getCajas();
    this.getCashiers();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
